module.exports = __webpack_public_path__ + "6d3072345168b77c9f4ecb078ec6c38a.png";